import React from "react";
import edu from "../../../img/Icons/Update/Work.png";
import IconLarge from "../../GeneralSubcomponents/IconLarge";
import jobs from "./jobs.json";
import "../../../Styles/education.css";

const Job = () => (
  <div className="edu">
    <div className="row o-icon-title ">
      <IconLarge iconL={edu} />
      <p> &nbsp; Employment History </p>
    </div>

    {jobs.map((job, index) => (
      <div key={`${job.company}-${index}`} className="o-exp-item">
        <div className="row o-edu-op">
          <div className="col-sm-7">
            <p className="o-edu">
              {job.company}
            </p>
          </div>
          <div className="col-sm-5">
            <p className="o-age">{job.startDate}</p>
          </div>
        </div>
        <div className="row">
          <p className=" o-det  col-sm-12">{job.jobTitle}</p>
        </div>
        <div className="row">
          <ul className="o-lp">
            {job.description.map((description, descriptionIndex) => (
                <li key={`${job.company}-${descriptionIndex}`}>{description}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
);
export default Job;
